import React, { useState } from 'react';

const DialogueChainHelp = () => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <div className="dialogue-chain-help">
      <button 
        className="button-19 help-button"
        onClick={() => setShowHelp(!showHelp)}
      >
        {showHelp ? 'Hide Chain Tips' : 'Dialogue Chain Tips'}
      </button>
      
      {showHelp && (
        <div className="help-content">
          <h4>Creating Dialogue Chains</h4>
          <p>
            You can easily create chains of dialogue from one NPC to another. The app will 
            automatically help you create these chains with less back-and-forth.
          </p>
          
          <div className="chain-steps">
            <div className="chain-step">
              <div className="step-number">1</div>
              <div className="step-content">
                <strong>Select the starting button</strong> - Find the first button in your chain 
                from the "Buttons and Commands" list and click "Select"
              </div>
            </div>
            
            <div className="chain-step">
              <div className="step-number">2</div>
              <div className="step-content">
                <strong>Point to the next dialogue</strong> - In the "Available Dialogues" 
                panel, find the dialogue you want to point to and click "Point Button"
              </div>
            </div>
            
            <div className="chain-step">
              <div className="step-number">3</div>
              <div className="step-content">
                <strong>Continue the chain</strong> - The app will automatically select the 
                first button from that dialogue, ready for you to point to the next dialogue
              </div>
            </div>
          </div>
          
          <div className="chain-example">
            <h5>Example Chain</h5>
            <div className="example-chain">
              <div className="chain-node">Mum (dialogue 0)</div>
              <div className="chain-arrow">↓</div>
              <div className="chain-node">Son (dialogue 0)</div>
              <div className="chain-arrow">↓</div>
              <div className="chain-node">Dad (dialogue 0)</div>
              <div className="chain-arrow">↓</div>
              <div className="chain-node">Mum (dialogue 1)</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DialogueChainHelp;
